import AlertIcon from "@redotech/redo-icons/alert-triangle.svg";
import { ShipmentFlag } from "@redotech/redo-model/outbound-labels/shipment-flag";
import { Flex } from "@redotech/redo-web/flex";
import { Text } from "@redotech/redo-web/text";
import { memo } from "react";
import * as styles from "./rates-error-message.module.css";

export const ShipmentFlagsDisplay = memo(function ShipmentFlagsDisplay({
  flags,
}: {
  flags: readonly ShipmentFlag[];
}) {
  if (!flags.length) {
    return null;
  }

  return (
    <Flex dir="column" gap="md">
      {flags.map((flag) => (
        <Flex key={flag.message}>
          <div className={styles.alertIcon}>
            <AlertIcon />
          </div>
          <Text fontSize="xs" fontWeight="medium" textColor="error">
            {flag.message}
          </Text>
        </Flex>
      ))}
    </Flex>
  );
});
